import { useSearchParams } from "react-router-dom";
import { PasswordUpdateContainer } from "@user-management-context/primary/user/password-update/password-update.container";

export const PasswordUpdatePage = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  if (!userId || !token || !email) return null;

  return <PasswordUpdateContainer userId={userId} token={token} email={email} />;
};
